import React, { useEffect } from 'react';
import { BannerMessage } from '../../global';
import styles from './Banner.module.scss';
import { useBanner } from '../../context/BannerContext';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface BannerComponentProps {
  banner: BannerMessage;
}

const BannerComponent: React.FC<BannerComponentProps> = ({ banner }) => {
  useEffect(() => {
    // This effect can be used to handle any side effects when the banner is mounted
    console.log('BannerComponent mounted');
    console.log('WINDOW');
    console.log(window.location);
    return () => {
      // Cleanup if necessary when the component unmounts
      console.log('BannerComponent unmounted');
      leavePage();
    };
  }, []);
  const { dismissBannerMessage, leavePage } = useBanner();
  const removeBanner = () => {
    // Logic to remove the banner, e.g., update state or call a context method
    console.log('Banner removed');
    dismissBannerMessage(banner.id);
  };

  const bannerStyle: React.CSSProperties = {
    background: banner.category === 'error' ? '#de8066dd' : banner.category === 'warning' ? '#f2b845dd' : '#c3de72dd',
  };
  const crossStyle: React.CSSProperties = {
    color: banner.category === 'error' ? '#de8066dd' : banner.category === 'warning' ? '#f2b845dd' : '#c3de72dd',
  };
  return (
    <div className={`d-flex flex-row align-items-center justify-content-center ${styles.banner}`} style={bannerStyle}>
      <div className="container d-flex flex-row align-items-center justify-content-center">
        <div className="row col-12 ">
          <div className="col-12  d-flex flex-row align-items-center justify-content-end">
            <div className="col-12 text-center align-self-end">
              <span className="sub-title color-light">{banner.title}</span>
            </div>
            <div className="">
              <button className={`${styles.removeButton}`} onClick={removeBanner}>
                <FontAwesomeIcon icon={faXmark as IconProp} style={crossStyle} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerComponent;
